<template>
  <div>
    <vs-card class="cardx">
      <div class="filters">
        <label>Desde:</label>
        <input type="datetime-local" v-model="filters.start">
        <label>Hasta:</label>
        <input type="datetime-local" v-model="filters.end">
        <vs-button @click="fetchVideos" size="small" color="primary" icon="search" class="ml-2"></vs-button>
      </div>

      <div v-if="isLoading" class="loading-container">
        <!-- <vs-icon icon="refresh" size="large" class="loading-icon"></vs-icon> -->
        <p>Cargando registros...</p>
      </div>

      <vs-table v-else-if="videos.length > 0" :data="videos">
        <template slot="thead">
          <vs-th>Nombre de Archivo</vs-th>
          <vs-th>Fecha y Hora</vs-th>
          <vs-th>Duración (seg)</vs-th>
          <vs-th>Tamaño (MB)</vs-th>
          <vs-th>Acciones</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.filename">{{ tr.filename }}</vs-td>
            <vs-td :data="tr.datetime">{{ formatDateTime(tr.datetime) }}</vs-td>
            <vs-td :data="tr.duration">{{ formatDuration(tr.duration) }}</vs-td>
            <vs-td :data="tr.size">{{ formatSize(tr.size) }}</vs-td>
            <vs-td>
                <!-- BOTONES DE ACCIÓN PARA ARCHIVOS COMPLETADOS -->
                <div v-if="tr.transfer_status === 'completed'" class="flex space-x-2">
                    <!-- Botón de Visualizar (Play) -->
                    <vs-button
                        class="bx bxs-paint-roll ml-3"
                        @click="openVideoPlayer(tr)"  
                        color="primary"
                        type="relief"  
                        icon="play_arrow" 
                        size="default">
                        Ver Video
                    </vs-button>
                </div>

              <template v-else-if="getTransferDisplay(tr).isButton">
                  <vs-button 
                      class="bx bxs-paint-roll ml-3" 
                      @click="postRequeve(tr)"  
                      color="darkgreen" 
                      type="relief" 
                      icon="swap_vert" 
                      size="default"
                      :disabled="tr.isTransferring"> 
                      {{ getTransferDisplay(tr).text }} 
                  </vs-button>
              </template>
              <template v-else> 
                <!-- Contenedor de progreso vertical (solución final) -->
                <div v-if="getTransferDisplay(tr).isProgress" class="progress-vertical">
                    <span class="progress-text-label">
                        {{ getTransferDisplay(tr).text }}
                    </span>
                    <vs-progress 
                        :percent="tr.transfer_progress" 
                        :color="getTransferDisplay(tr).color"
                        type="line">
                    </vs-progress>
                </div>
                  <div v-else>
                      <span :style="{ color: getTransferDisplay(tr).color, fontWeight: 'bold' }">
                          {{ getTransferDisplay(tr).text }}
                      </span>
                  </div>
              </template>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div v-else class="no-records">
        No se encontraron videos para los filtros seleccionados.
      </div>

      <vs-popup :title="'Visualizando: ' + currentVideo.filename" :active.sync="isPlayerActive" fullscreen>
        <div v-if="currentVideo.id" class="video-player-container">
            
            <div class="download-button-overlay">
                <vs-button 
                    @click="startDownload(currentVideo)"
                    color="success" 
                    type="relief" 
                    icon="cloud_download" 
                    size="default">
                    Descargar
                </vs-button>
            </div>

            <video controls :src="getVideoUrl(currentVideo, 'view')" class="w-full h-full object-contain">
                Tu navegador no soporta el tag de video.
            </video>
        </div>
    </vs-popup>

    </vs-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "VideoList",
  props: {
    box_id: {
      type: Number,
      required: true,
    },
  },
  // --- CAMBIO A LA SINTAXIS MÁS SEGURA Y TRADICIONAL DE VUE 2 ---
  data() { 
    return {
      videos: [],
      filters: {
        start: '',
        end: '',
      },
      isLoading: false,
      pollingInterval: null,
      isPlayerActive: false,
      currentVideo: {},
    }
  },
methods: {
    postRequeve(video) { 
        // 1. Activar el estado de carga solo para este objeto de video
        // Usamos $set para asegurar la reactividad
        this.$set(video, 'isTransferring', true);

        const url_api = this.$store.state.url_api;
        const payload = { 
            id: this.box_id, 
            file: video.filename // Usa el nombre de archivo del objeto
        };

        axios.post(url_api + 'api/videofile/request_trx', payload)
            .then(response => {
                const data = response.data;
                
                if (data.isOk === true) {
                    this.$vs.notify({
                        title: 'Éxito',
                        text: data.message,
                        color: 'success',
                        position: 'top-right'
                    });
                    this.fetchVideos(); 
                } else {
                    this.$vs.notify({
                        title: 'Fallo en la Transferencia',
                        text: data.message || 'La Box no pudo iniciar la transferencia.',
                        color: 'warning',
                        position: 'top-right'
                    });
                }
            })
            .catch(() => {
                // console.error("Error al solicitar la transferencia:", error);
                this.$vs.notify({
                    title: 'Error de Conexión',
                    text: 'No se pudo contactar al servidor o hubo un error de red.',
                    color: 'danger',
                    position: 'top-right'
                });
            })
            .finally(() => {
                // 2. Desactivar el estado de carga para este objeto de video
                this.$set(video, 'isTransferring', false); 
            });
    },
    fetchVideos() {
      // Detener el polling anterior al hacer una nueva búsqueda
      this.stopPolling();
      
      const url_api = this.$store.state.url_api;
      const params = { box_id: this.box_id };

      if (this.filters.start && this.filters.end) {
        params.start_date = this.filters.start.replace('T', ' ');
        params.end_date = this.filters.end.replace('T', ' ');
      }
      
      this.isLoading = true;
      axios.get(url_api + 'api/videolist', { params })
        .then(response => {
          this.videos = response.data;
          // Nuevo: Iniciar el monitoreo después de cargar la lista
          this.startPolling(); 
        })
        .catch(() => {
          // console.error("Error al obtener la lista de videos:", error);
          this.videos = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 1. Obtiene la URL de descarga/visualización
    getVideoUrl(video, type = 'view') { 
      if (!video || !video.id) return '';
      const url_api = this.$store.state.url_api;
      
      // Si usaste el endpoint dedicado:
      const endpoint = (type === 'view') ? 'view' : 'download';
      return `${url_api}api/videofile/${endpoint}/${video.id}`;
    },

    startDownload(video) {
      // 1. Obtener la URL de descarga (asegúrate de que el backend use as_attachment=True)
      const downloadUrl = this.getVideoUrl(video, 'download'); 
      
      // 2. Crear un elemento 'a' oculto
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', video.filename); // Sugiere el nombre del archivo
      link.style.display = 'none';
      
      // 3. Añadirlo al cuerpo del documento, simular el clic y eliminarlo
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.$vs.notify({
          title: 'Descarga Iniciada',
          text: `Descargando: ${video.filename}`,
          color: 'primary',
          position: 'top-right'
      });
    },

    // 3. Abre el MODAL para VISUALIZACIÓN (Play)
    openVideoPlayer(video) {
        this.currentVideo = video;
        this.isPlayerActive = true;
    },

    // Muestra el estado o progreso en la columna de acciones
    getTransferDisplay(video) {
        const status = video.transfer_status;

        if (status === 'completed') {
            // CAMBIO CLAVE: No devuelve texto ni color, ya que usaremos botones dedicados
            return { text: '', color: 'success' }; 
        }
        if (status === 'none') {
            // Devuelve el botón si no hay solicitud de transferencia
            return { text: 'Transferir', color: 'primary', isButton: true }; 
        }

        // Para estados en progreso
        const progress = video.transfer_progress || 0;
        let text = 'Descarga Iniciada';
        let color = 'warning';

        if (status === 'in_progress') {
            const roundedProgress = Math.round(progress);
            text = `Descargando: ${roundedProgress}%`;
            color = 'primary';
        }else if (status === 'started') {
            text = `Descarga Solicitada (0%)`;
        }

        return { text: text, color: color, isProgress: true };
    },

    startPolling() {
        // Ejecutar la primera vez inmediatamente y luego cada 3 segundos
        this.updateProgress();
        this.pollingInterval = setInterval(this.updateProgress, 99993000); 
    },

    stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    },

    updateProgress() {
        const url_api = this.$store.state.url_api;
        
        // 1. Verificar si hay videos que requieren monitoreo (cualquier estado diferente a 'none' o 'completed')
        const needsMonitoring = this.videos.some(v => 
            v.transfer_status && v.transfer_status !== 'none' && v.transfer_status !== 'completed'
        );

        if (!needsMonitoring && this.videos.length > 0) {
            // Si no hay nada que monitorear, detenemos el polling
            this.stopPolling();
            return;
        }
        
        // Si no hay videos en la lista, tampoco hacemos polling
        if (this.videos.length === 0) return;

        axios.get(url_api + 'api/transfer_progress', { params: { box_id: this.box_id } })
            .then(response => {
                const updates = response.data; // Lista de {filename, status, progress}
                
                // Mapear las actualizaciones a la lista de videos
                updates.forEach(update => {
                    const videoIndex = this.videos.findIndex(v => v.filename === update.filename);
                    if (videoIndex !== -1) {
                        // Usamos Vue.set para asegurar la reactividad en el objeto
                        this.$set(this.videos[videoIndex], 'transfer_status', update.status);
                        this.$set(this.videos[videoIndex], 'transfer_progress', update.progress);
                    }
                });

                // Después de la actualización, re-chequeamos si hay que detener el polling
                const stillNeedsMonitoring = this.videos.some(v => 
                    v.transfer_status === 'started' || v.transfer_status === 'in_progress'
                );
                if (!stillNeedsMonitoring) {
                    this.stopPolling();
                }

            })
            .catch(() => {
                // console.error("Error al obtener el progreso de transferencia:", error);
                // En caso de error de red, detenemos para no sobrecargar el sistema
                this.stopPolling();
            });
    },
    formatDateTime(isoString) {
      if (!isoString) return '';
      const date = new Date(isoString);
      return date.toLocaleString('es-CL');
    },
    formatDuration(secondsStr) {
        const seconds = parseFloat(secondsStr);
        return isNaN(seconds) ? 'N/A' : seconds.toFixed(2);
    },
    formatSize(bytes) {
        if (bytes === 0) return '0 MB';
        const megabytes = bytes / (1024 * 1024);
        return `${megabytes.toFixed(2)} MB`;
    }
  },
  mounted() {
      this.fetchVideos();
  },
  beforeDestroy() {
      // Es crucial detener el polling al destruir el componente
      this.stopPolling();
  }
};
</script>

<style scoped>
/* Nuevos estilos para el apilamiento vertical */
.progress-vertical {
    display: flex; /* Habilitar flexbox */
    flex-direction: column; /* Apilar elementos verticalmente */
    align-items: flex-start; /* Alinear el texto a la izquierda */
    width: 100%; /* Ocupar todo el ancho de la celda */
    gap: 2px; /* Espacio mínimo entre texto y barra */
}

/* Estilo para el texto de progreso (arriba) */
.progress-vertical .progress-text-label {
    font-size: 0.85em; /* Tamaño de fuente más pequeño */
    font-weight: bold;
    /* Asegurar que el texto ocupe su propio espacio */
    line-height: 1.2; 
}

/* Forzar el componente vs-progress a ocupar todo el ancho */
.progress-vertical .vs-progress {
    width: 100%; 
    margin: 0 !important;
}

/* Estilo para el reproductor de video dentro del modal fullscreen */
.video-player-container {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000; /* Fondo oscuro para el video */
    position: relative; /* Clave para posicionar el overlay */
}
.video-player-container video {
    max-height: 100%;
    max-width: 100%;
}
/* Estilo para el botón de descarga flotante */
.download-button-overlay {
    position: absolute;
    top: 15px; /* Margen superior */
    right: 15px; /* Margen derecho */
    z-index: 1000; /* Asegurar que esté encima del video */
}
.filters {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}
.filters label {
    font-weight: bold;
}
.filters input[type="datetime-local"] {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
}
.ml-2 {
    margin-left: 0.5rem;
}
.no-records, .loading-container {
  font-weight: bold;
  font-size: 1.1em;
  text-align: center;
  margin-top: 30px;
  padding: 20px;
}
.loading-icon {
  animation: spin 1.5s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>